import Component from '@glimmer/component';

import type ActionModel from 'frontend/models/action';
import { ActionType } from 'common/enums/action-type.enum';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import config from 'frontend/config/environment';
import { action } from '@ember/object';

export interface PagesApplyBaseArgs {
  action: ActionModel;
}

export default class PagesApplyBase<
  T extends PagesApplyBaseArgs
> extends Component<T> {
  @service declare router: RouterService;
  get isVirtualAction() {
    const action = this.args.action;
    if (!action) return false;
    return this.args.action.type === ActionType.Virtual;
  }

  @action
  async goBackToProductOrAction() {
    await this.transitionToProductOrAction();
  }

  public async transitionToProductOrAction() {
    if (this.isVirtualAction) {
      const product = await this.args.action.product;
      if (config.environment !== 'test') {
        return this.router.transitionTo('catalog.product', product.slug);
      }
    }
    return this.router.transitionTo('catalog.action');
  }
}
